<template>
  <div class="content contentBody">
    <div style="display: none;">
      <el-upload
              class="avatar-uploader"
              :action="uploadImg"
              :show-file-list="false"
              :data="data_"
              :on-success="logohandleAvatarSuccess"
              :before-upload="logobeforeAvatarUpload"
      >
        <img :src="logo" class="avatar"/>
      </el-upload>
    </div>
    <div class="echart_wrap">
      <div class="search_wrap mb-20">
        <el-radio-group v-model="radio1" size="small">
          <el-radio-button label="最近7天"></el-radio-button>
          <el-radio-button label="最近15天"></el-radio-button>
          <el-radio-button label="最近30天"></el-radio-button>
          <el-radio-button label="自定义时间"></el-radio-button>
        </el-radio-group>
      </div>
      <h2 class="echart_type">获客/分享趋势图</h2>
      <div class="material_echart" id="material_echart"></div>
    </div>
    <div class="share_source">
      被分享文章来源
      详细数据
      <div class="condition">
        <div class="check_wrap">
          <el-radio-group v-model="radio1" size="small">
            <el-radio-button label="全部"></el-radio-button>
            <el-radio-button label="企业公众号"></el-radio-button>
            <el-radio-button label="企业自定义添加"></el-radio-button>
            <el-radio-button label="企业员工提供"></el-radio-button>
          </el-radio-group>
        </div>
        <div class="search_wrap">
          <el-form :inline="true" :model="formdata" class="form-inline">
            <el-form-item>
              <el-input v-model="formdata.user" placeholder="请输入文章标题" size="small"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="small"></el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table_wrap">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="date" label="文章标题"></el-table-column>
          <el-table-column prop="name" label="来源"></el-table-column>
          <el-table-column prop="address" label="详细来源"></el-table-column>
          <el-table-column prop="address" label="状态">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.value" active-color="#2AA3F8" inactive-color="#ff4949"></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="发布时间"></el-table-column>
          <el-table-column prop="address" label="分享次数"></el-table-column>
          <el-table-column prop="address" label="获客数"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <span @click="datadetail(scope.row)" class="action_btn">查看数据</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pag_wrap">
          <el-pagination background layout="prev, pager, next" :total="0"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import api from "@/api.js"

  var echarts = require("echarts");
  export default {
    name: "MaterialData",
    data() {
      return {
        logo: '',
        uploadImg: api.uploadTokenImg,
        data_: {token: sessionStorage.getItem("token")},
        formdata: {
          user: ""
        },
        radio1: "",
        tableData: [
          {
            date: "---",
            name: "---",
            address: "---"
          }
        ]
      };
    },
    mounted() {
      this.echarts();
    },
    methods: {
      echarts() {
        var myChart = echarts.init(document.getElementById("material_echart"));

        let option = {
          tooltip: {
            trigger: "axis"
          },
          legend: {
            data: []
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },

          xAxis: {
            type: "category",
            boundaryGap: false,
            data: []
          },
          yAxis: {
            type: "value"
          },
          series: []
        };

        myChart.setOption(option);
      },
      // 分享明细
      datadetail() {
        this.$router.push({name: "dataMember"});
      }
    }
  };
</script>
